<div class="cliente-central-compra-form-control-text">
    <label class="col-form-label">
        Central de Compras
    </label>
    <div class="input-group">                        
        <input type="text" class="form-control" [value]="nomeFantasia ? nomeFantasia : nome" disabled="disabled" readonly="readonly">
        <div class="input-group-append" *ngIf="isShowBtnOpen">
            <button type="button" class="btn btn-light" (click)="openCentralCompra.emit(id)" title="Abrir Central de Compras">
                <i class="fas fa-search"></i>
            </button>
        </div>        
    </div>
    <p class="form-text text-muted form-text-nome" *ngIf="nomeFantasia">
        {{nome}}
    </p>
    <p class="form-text text-muted">
        {{helpText}}
    </p>
</div>